import React from "react";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import { GET_FINANCIALS } from "../services/Apis";
import axios from "axios";
import { useEffect, useState } from "react";

const Helpdesk = () => {
  const [SidebarState, setSidebarState] = useState(false);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const user = {
    id: encStorage.getItem("id"),
    name: encStorage.getItem("name"),
    client_code: encStorage.getItem("client_code"),
    id: encStorage.getItem("id"),
  };
  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content">
          <div className="container mt-3">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <h2 className="text-center mb-3 text-primary">Helpdesk</h2>
                <div className="row">
                  <div className="col-md-4">
                    <div className="card shadow border-0">
                      <div className="card-body text-center">
                        <h4 className="card-title text-center">
                          How to Deposit?
                        </h4>
                        <video controls className="w-50 video-control">
                          <source src="https://zedlytics.s3.me-central-1.amazonaws.com/deposit.mp4" />
                        </video>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card shadow border-0">
                      <div className="card-body text-center">
                        <h4 className="card-title text-center">
                          How to Withdraw?
                        </h4>
                        <video controls className="w-50 video-control">
                          <source src="https://zedlytics.s3.me-central-1.amazonaws.com/withdraw.mp4" />
                        </video>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card shadow border-0">
                      <div className="card-body text-center">
                        <h4 className="card-title text-center">
                          Reset Password?
                        </h4>
                        <video controls className="w-50 video-control">
                          <source src="https://zedlytics.s3.me-central-1.amazonaws.com/password-reset.mp4" />
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Helpdesk;
